const defaultState = {
  available: null,
  contracted: null,
  isFetching: false,
  error: false,
};

export default function shifts(state = defaultState, action) {
  switch (action.type) {
    case 'MAINTENANCE_PLAN_CRECEIVED':
      return {
        isFetching: false,
        ...state,
        available: normalizePlan(action.payload.available),
        contracted: action.payload.contracted,
      };
    case 'MAINTENANCE_PLAN_REQUESTED':
      return { isFetching: true, ...state };
    case 'MAINTENANCE_PLAN_FAILED':
      return { isFetching: false, error: true, ...state };
    default:
      return state;
  }
}

function normalizePlan(plan = {}) {
  if (plan && plan.services) {
    plan.services = plan.services.filter(plan => plan.price > 0);
  }

  return plan;
}
